import { useContext } from 'react';
import { alteracaoIbsCbsLoteContextData } from '../types/context';
import { alteracaoIbsCbsLoteContext } from '../context/AlteracaoIbsCbsLoteContext';

export const useAlteracaoIbsCbsLote = (): alteracaoIbsCbsLoteContextData =>
  useContext(alteracaoIbsCbsLoteContext);
